const quotationChat = {
  quotationChatNavLabel: "Offerte-chat", // translated 
  quotationChatApprovalTitle: "Offerte-chat", // translated 
  quotationChatAccountNotApprovedTitle: "Account Niet Goedgekeurd", // translated 
  quotationChatAccountNotApprovedDescription:
    "Uw account is nog niet goedgekeurd. Neem contact op met uw accountmanager voor meer informatie.", // translated 
  quotationChatViewAiChat: "Bekijk A.I.-chat", // translated 

  quotationRequestChatSessions: "Chatsessies", // translated 
  quotationRequestChatNoPastSessions: "Geen eerdere sessies", // translated 
  quotationRequestChatNewChat: "Nieuwe Chat", // translated 
  quotationRequestChatCloseSidebar: "Zijbalk", // translated 
  quotationRequestChatSessionFallback: "Chat", // translated 
  quotationRequestChatDefaultSessionName: "Nieuwe chat", // translated 
  quotationRequestChatTitle: "Offerte-chat", // translated 
  quotationRequestChatResponseLanguageLabel: "Antwoordtaal", // translated 
  quotationRequestChatOpenSidebar: "Zijbalk openen", // translated 
  quotationRequestChatRenameSession: "Sessie hernoemen", // translated 
  quotationRequestChatDeleteSession: "Sessie verwijderen", // translated 
  quotationRequestChatToggleDarkMode: "Donkere modus wisselen", // translated 
  quotationRequestChatSwitchToLightMode: "Overschakelen naar lichte modus", // translated 
  quotationRequestChatSwitchToDarkMode: "Overschakelen naar donkere modus", // translated 
  quotationRequestChatEmptyStateHeading: "Start een Nieuw Offerteaanvraaggesprek", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Beschrijf uw reisbehoeften en ik maak een offerteaanvraag voor u.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Typ uw bericht om een gesprek te starten... (Shift+Enter voor nieuwe regel)", // translated 
  quotationRequestChatMessagePlaceholder: "Typ uw bericht... (Shift+Enter voor nieuwe regel)", // translated 
  quotationRequestChatUploadFile: "Bestand uploaden", // translated 
  quotationRequestChatUploadAttachment: "uploaden", // translated 

  quotationRequestChatStopGenerating: "Genereren stoppen", // translated 
  quotationRequestChatGenerateQuotation: "Offerte genereren", // translated 
  quotationRequestChatGenerateFinalQuotation: "Definitieve Offerte Genereren", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Offerte Afronden", // translated 
  quotationRequestChatHoldToRecord: "Onderdrukt houd een spraakbericht op te nemen", // translated 
  quotationRequestChatRecordingReleaseToSend: "Opnemen, loslaten om te verzenden", // translated 
  quotationRequestChatRecording: "Opening...", // translated 
  quotationRequestChatSelectSessionFirst: "Selecteer eerst een chatsessie.", // translated 
  quotationRequestChatCancelVoiceRecording: "Spraak", // translated 
  quotationRequestChatListening: "en...", // translated 
  quotationRequestChatTranscribing: "Transcriberen...", // translated 

  quotationRequestChatFileUploadedSuccess: "Bestand succesvol", // translated 
  quotationRequestChatFailedCreateSession: "Chatsessie aanmaken mislukt. Probeer het opnieuw.", // translated 
  quotationRequestChatFailedUploadFile: "Bestand uploaden mislukt. Probeer het opnieuw.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Beantwoord de openstaande vragen voordat u een ander bericht verstuurt.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Beantwoord de openstaande vragen voordat u de offerteaanvraag afrondt.", // translated 
  quotationRequestChatFavoriteMarked: "Chatsessie duidelijk als favoriet", // translated 
  quotationRequestChatFavoriteUnmarked: "Chatsessie niet meer als favoriet gemarkeerd", // translated 
  quotationRequestChatFailedSetFavorite: "Als favoriete markeren mislukt", // translated 
  quotationRequestChatFailedUnsetFavorite: "Favorieten verwijderen", // translated 
  quotationRequestChatRenamedSuccess: "Chatsessie succesvol hernoemd.", // translated 
  quotationRequestChatFailedRename: "Chatsessie hernoemen mislukt. Probeer het opnieuw.", // translated 
  quotationRequestChatDeletedSuccess: "Chatsessie succesvol verwijderd.", // translated 
  quotationRequestChatFailedDelete: "Chatsessie verwijderen mislukt. Probeer het opnieuw.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "succesvol verwijderd.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Bijlage verwijderen mislukt. Probeer het opnieuw.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Offerteaanvraag succesvol aangevraagd! Uw aanvraag wordt verwerkt.", // translated 
  quotationRequestChatFailedSubmit: "Offerteaanvraag indienen mislukt", // translated 
  quotationChatPdfDownloadedSuccess: "PDF succesvol gedownload!", // translated 
  quotationChatFailedGeneratePdf: "PDF genereren", // translated 

  quotationRequestChatSubagentRequired:
    "Selecteer een subagent indien-gebruiker voordat u de offerte aanvraagt.", // translated 
  quotationRequestChatAppUserLoading:
    "Uw CRM-appgebruikersprofiel wordt niet geladen. Probeer het meer dan een moment opnieuw.", // translated 
  quotationRequestChatAppUserMismatch:
    "Uw CRM-appgebruikersprofiel komt niet overeen met deze chatsessie.", // translated 

  quotationRequestChatRenameTitle: "Chat Hernoemen", // translated 
  quotationRequestChatSessionName: "Sessienaam", // translated 
  quotationRequestChatEnterSessionName: "Voer sessienaam in", // translated 
  quotationRequestChatSaving: "...", // translated 
  quotationRequestChatSave: "Opslaan", // translated 
  quotationRequestChatDeleteTitle: "Chatfen", // translated 
  quotationRequestChatDeleteConfirm: "Weet u zeker dat u deze chatsessie wilt verwijderen?", // translated 
  quotationRequestChatDeleteCannotUndo: "Deze actie kan niet worden gemaakt.", // translated 
  quotationRequestChatDeleting: "en...", // translated 
  quotationRequestChatDelete: "tjo", // translated 

  quotationRequestChatAttachmentsTitle: "n Offerte-chat", // translated 
  quotationRequestChatLoadingAttachments: "n geladen...", // translated 
  quotationRequestChatNoAttachments: "Geen n gevonden", // translated 
  quotationRequestChatDeleteAttachment: "verwijderen", // translated 
  quotationRequestChatUploadingAttachment: "uploaden...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Zelfs geduld terwijl uw bestand wordt opgelost.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Openstaande Vragen Beantwoorden", // translated 
  quotationRequestChatProposeOwnAnswer: "Eigen voorstellen", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Typ uw eigen opgaven...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{antwoordde}} van {{totaal}} beantwoord", // translated 
  quotationRequestChatReadyToSubmit: "Klaar om in te dienen", // translated 
  quotationRequestChatSubmitAll: "Alles", // translated 
  quotationRequestChatRespondToOneQuestion: "Reageer op {{count}} vraag", // translated 
  quotationRequestChatRespondToManyQuestions: "Reageer op {{count}} vragen", // translated 

  quotationRequestChatFinalizeTitle: "Offerte Afronden", // translated 
  quotationRequestChatLoadingSessionData: "Sessiegegevens laden...", // translated 
  quotationRequestChatErrorLoadingSession: "Fout bij laden van sessiegegevens. Probeer het opnieuw.", // translated 
  quotationRequestChatQuotationTitle: "Offertetitel", // translated 
  quotationRequestChatExtraComments: "Extra heiden", // translated 
  quotationRequestChatSubmitting: "Indienen...", // translated 
  quotationRequestChatSubmit: "Indienen", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Offerte d'...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Zelfs geduld terwijl uw offerteaanvraag wordt ingediend.", // translated 

  quotationRequestChatSelectSubagent: "Subagent Selecteren", // translated 
  quotationRequestChatSearchSubagents: "Subagenten...", // translated 
  quotationRequestChatLoadingSubagents: "Subagenten geladen...", // translated 
  quotationRequestChatNoSubagentsFound: "Geen subagenten gevonden", // translated 
  quotationRequestChatNoSubagentsAvailable: "Geen subagenten beschikbaar", // translated 
  quotationRequestChatSelectedSubagent: "Geselecteerd: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Subagent-gebruikers", // translated 
  quotationRequestChatSearchUsers: "Gebruikers...", // translated 
  quotationRequestChatNoUsersFound: "Geen gebruikers gevonden", // translated 
  quotationRequestChatNoUsersAvailable: "Geen gebruikers beschikbaar", // translated 

  quotationChatDownloadSummaryTitle: "Download Uw Offertesamenvatting", // translated 
  quotationChatDownloadSummaryDescription:
    "Vul hieronder uw gegevens in om een gepersonaliseerde PDF-samenvatting van uw reisofferte te genereren. De PDF bevat alle reisdetails, essentiële, vervoersinformatie en een dag-tot-dag reisplan.", // translated 
  quotationChatCustomerTitle: "Titel", // translated 
  quotationChatSelectTitle: "Titel", // translated 
  quotationChatHonorificMr: "Dhr.", // translated 
  quotationChatHonorificMrs: "Mevr.", // translated 
  quotationChatHonorificMs: "Mej.", // translated 
  quotationChatHonorificDr: "Dokter", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Telefoon", // translated 
  quotationChatCustomerCompany: "Bedrijf", // translated 
  quotationChatCustomerMessage: "Bericht", // translated 
  quotationChatCustomerCountry: "Land", // translated 
  quotationChatGenerating: "Genereren...", // translated 
  quotationChatDownloadPdf: "PDF downloaden", // translated 

  quotationChatTripSummary: "Reissamenvatting", // translated 
  quotationChatDownloadAsPdf: "Downloaden als PDF", // translated 
  quotationChatNoTripSummary: "Geen reisamenvatting beschikbaar voor deze sessie.", // translated 

  quotationRequestChatThinking: "Denken...", // translated 
  quotationRequestChatSources: "Bronnen", // translated 
  quotationRequestChatSearchingWebFor: 'Zoeken op het web naar: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Diensten Uitgevoerd door Touroperator", // translated 
  quotationRequestChatServicesByCustomer: "Diensten Afhandeld door Klant", // translated 
  quotationRequestChatReadyNotice:
    "U kunt nu een offerte genereren voor deze aanvraag door op de knop rechts te klikken.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Definitieve offerte genereren", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Misschien wilt u vragen:", // translated 
  quotationRequestChatClickToSendSuggestion: "Klik om dit bericht te verzenden", // translated 

  quotationRequestChatAddToFavorites: "Toevoegen aan", // translated 
  quotationRequestChatRemoveFromFavorites: "tuit", // translated 
  quotationRequestChatSubmitted: "In", // translated 

  quotationRequestChatQuotationRequest: "Offerteaanvraag: {{referentie}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{titel}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Status: {{status}}", // translated 

  quotationChatLoading: "Beladen...", // translated 
  quotationChatSessionNotFound: "Chatsessie niet gevonden voor deze offerte", // translated 
  quotationChatMemberSessionNotFound: "Ledensessie niet gevonden voor uw account", // translated 
  quotationChatUnableToConnect: "Kan geen verbinding maken met chat", // translated 
  quotationChatConnecting: "Verbinden...", // translated 
  quotationChatTypeYourMessage: "typ uw bericht...", // translated 
  quotationChatConnected: "Verbonden", // translated 
  quotationChatConnectingStatus: "Verbinden...", // translated 
  quotationChatDisconnected: "Verbroken", // translated 
};


export default quotationChat;
